export default __webpack_public_path__ + "static/media/road-B-photo.80fd8f5d.svg";